@if (!operator.hasRule() && operator.name === null) {
  <ng-container i18n>Unnamed composite rule</ng-container>
}
@if (operator.hasRule() && operator.name === null) {
  <ng-container i18n>Unnamed rule</ng-container>
}
@if (operator.name !== null) {
  {{ operator.name }}
}
